<template>
	<div class="st-main-content">
        <div class="data-table-box">
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showPage="true"
				:loading="loading"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
                <template slot="startTimeDesc" slot-scope="scope">
                    <span v-if="scope.row.startTimeDesc==='无限期'">无限期</span>
                    <span v-else><span>{{scope.row.startTimeDesc}}至{{scope.row.endTimeDesc}}</span></span>        
                </template>
                <template slot="updateTime" slot-scope="scope">
                    <span v-if="scope.row.useState === 'USED'">{{scope.row.updateTime}}</span>
                </template>
			</common-table>
        </div>
	</div>
</template>
<script>
export default {
	name: 'DriverAccount',
	props: [],
	components: {},
	data(){
		return{
            tableColumns:[
                {
                    key: 'name',
                    align:'center',
                    title: '名称',
                },{
                    key: 'phone',
                    align:'center',
                    title: '手机号',
                },{
                    key: 'genreDesc',
                    align:'center',
                    title: '优惠券名称',
                },{
                    key: 'fieldValue',
                    align:'center',
                    title: '面值（元）',
                },{
                    align:'center',
                    slotName:'startTimeDesc',
					slot:true,
                    title: '有效期',
                },{
                    key: 'useStateDesc',
                    align:'center',
                    title: '是否使用',
                },{
                    key: 'createTime',
                    align:'center',
                    title: '领取时间',
                },{
                    slotName:'updateTime',
                    slot:true,
                    align:'center',
                    title: '使用时间',
                }
            ],
            loading: false,
            pageConfig: {
                total: 0,
                pageSize: 100,
                currentPage: 1,
            },
            bottomHandleArr: [
                // {
                //     label: '导出',
                //     handler: () => this.exportTable()
                // }
            ],
			dataList:[], //订单列表
            dataTotal: {},
            orderForm:{
                uid:''
            },
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			toggleStDialog:false,// 弹窗
			userTypeList:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '货主'
				}, {
					value: 2,
					label: '司机'
				}],
		}
	},
	methods: {
        sizeChange(size) {
            this.pageConfig.currentPage = 1
            this.pageConfig.pageSize = size
            this.searchList()
        },

        currentChange(currentPage) {
            this.pageConfig.currentPage = currentPage
            this.searchList()
        },
		getSummaries(param) {
            // 处理合计不显示问题
            this.$nextTick(() => {
                this.$refs.table.doLayout();
            });
            let vm = this;
            let sums = [];
            var selectedColm = param.columns;
            let newArray = []
            selectedColm.forEach(a => {
                if (vm.dataTotal[a.property]) {
                newArray.push(vm.dataTotal[a.property])
                } else {
                newArray.push('')
                }
                
            });
            sums = newArray;
            sums[0] = "合计";
            return sums;
        },
		cellClass(row){     
			if (row.columnIndex === 0) {           
				return 'disabledCheck'     
			} 
		},
		selectionChange(val){
			this.selectedList=val;
		},
		searchList(){
			let pages={};
			pages.size = this.pageConfig.pageSize;
            pages.current = this.pageConfig.currentPage;
            let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		getData(data){
			this.$server.financial.queryDetail(data,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		// 导出
		exportTable(){
			if (this.dataList.length < 1) {
                this.$toast.stMessage('暂无订单', true)
                return;
			}
			let pages = {};
			pages.size = this.listPage.currentSize;
			pages.current = this.listPage.current;
			const sendData = {
                ...this.orderForm,
			    exportColumnFiledNames: this.tableColumns.map((item) => {
					return  item.key || item.slotName
				}).filter(item => {
					return item && item.trim()
				})
            }
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/finance/ownerAccountBalanceExport', sendData, (res) => {
			    console.log('导出成功')
			})
			
		},
	},
    activated() {
        this.orderForm.uid = this.$route.params.uid ;
        this.searchList()
    },
}

</script>
<style scoped>

.driver-account {
  width: 100%;
  height: auto;
}
.data-table-box {
	
    height: auto;
    background: #FFF;
    padding: 8px;
	box-sizing: border-box;
	text-align: center;
}	
.data-table-warp{
	width: auto;
	margin: 0 auto;
}
.data-table{
	margin-bottom: 8px;
}
.query-setting-box-left{
    flex-grow: 0;
}
</style>
